import { loadStripe } from "@stripe/stripe-js";

// Get the publishable key from environment variables or hardcode for development
// const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Hardcoded for development (replace with your actual key)
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  throw new Error(
    "Missing Stripe publishable key. Please set REACT_APP_STRIPE_PUBLISHABLE_KEY in your environment variables or hardcode it in this file."
  );
}

// Initialize Stripe
export const stripePromise = loadStripe(stripePublishableKey);

// Stripe configuration
export const stripeConfig = {
  publishableKey: stripePublishableKey,
  currency: "usd",
  country: "US",
};
